export default "/images/vendor/flag-icon-css/flags/4x3/bw.svg?8a35721e3f5ff275ace83b5654e857a7";